import React from "react";

import "./photo-preprocess-progress.css";

export const PhotoPreprocessProgress = ({ message }: { message: string }) => (
	<div className="photo-preprocess-progress">{message}</div>
);
PhotoPreprocessProgress.displayName = "PhotoPreprocessProgress";
